import { Card } from "../../components/Card";
import { EsmPlanList } from "../../components/EsmPlanList";
import { EsmSpeedometerProducer } from "../../components/EsmSpeedometerProducer";
import { HeaderCardESM } from "../../components/Header";
import { Button } from "../../components/Button";
import { EmptyGraph } from "../../components/Empty";
import { ESMModalActions } from "../../components/ModalActions";
import "./styles.scss";

export const ESMCommunityPlanScreen = ({
  goBack,
  indicatorActions,
  actions,
  handleOpenActionsModal,
  handleCloseActionsModal,
  handleChangeIsComplete,
  showModalActions,
  isCommunity,
  scopeType,
  ...props
}) => {
  return <>
    <Card>
      <HeaderCardESM title={props?.title} {...{ goBack }}>
        <div className="header-action__container">
          {scopeType === 'project' &&
            <Button
              label="Adicionar Ações"
              color="orange"
              handleClick={handleOpenActionsModal}
            />
          }
        </div>
      </HeaderCardESM>
      <div className="esm-community__container">
        <EsmSpeedometerProducer
          scaleTitle={parseFloat(props?.value || 0).toFixed(1)}
          scaleValue={props?.value}
          hiddenCards
        />
        {actions?.length ?
          <EsmPlanList actionList={actions} isFromCommunity={isCommunity} /> :
          <div className="empty-table__container"><EmptyGraph /></div>
        }
      </div>
    </Card>
    <ESMModalActions
      {...{
        actionList: indicatorActions,
        handleCloseActionsModal,
        showModalActions,
        actionType: isCommunity ? 'actionCommunity' : 'actionProducer',
        ...props
      }}
    />
  </>
}